export class AdvisingAbnormalItemFileBase64Bean {
  fileName: string | null;
  fileExtension: string | null;
  fileType: string | null;
  fileBase64s: string | null;

  constructor() {
    this.fileName = null;
    this.fileExtension = null;
    this.fileType = null;
    this.fileBase64s = null;
  }
}
